export default __webpack_public_path__ + "static/media/img_muslinTwoEars_yg.07385581.jpg";